import React from 'react';

interface MapIconProps{
  className?: string;
}

const MapIcon: React.FC<MapIconProps> = ({
  className
}) => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M1.52637 5.68649V12.1732C1.52637 13.4398 2.42637 13.9598 3.5197 13.3332L5.08637 12.4398C5.42637 12.2465 5.99303 12.2265 6.34637 12.4065L9.84637 14.1598C10.1997 14.3332 10.7664 14.3198 11.1064 14.1265L13.993 12.4732C14.3597 12.2598 14.6664 11.7398 14.6664 11.3132V4.82649C14.6664 3.55982 13.7664 3.03982 12.673 3.66649L11.1064 4.55982C10.7664 4.75315 10.1997 4.77315 9.84637 4.59315L6.34637 2.84649C5.99303 2.67315 5.42637 2.68649 5.08637 2.87982L2.1997 4.53315C1.82637 4.74649 1.52637 5.26649 1.52637 5.68649Z" stroke="#003D6B" strokeLinecap="round" stroke-linejoin="round"/>
    <path d="M5.70703 3.1665V11.8332" stroke="#003D6B" strokeLinecap="round" stroke-linejoin="round"/>
    <path d="M10.4863 4.91357V13.8336" stroke="#003D6B" strokeLinecap="round" stroke-linejoin="round"/>
    </svg>
    

  );
};

export default MapIcon;




